import { cn } from "@/shared/lib/cn";

type CardShellProps = {
  children: React.ReactNode;
  className?: string;
};

export function CardShell({ children, className }: CardShellProps) {
  return (
    <div className={cn("theme-card theme-card-interactive p-6", className)}>{children}</div>
  );
}
